import React, { useEffect, useState } from "react";
import InputField from "../../../components/inputfield/InputField";
import SelectBox from "../../../components/select box/SelectBox";
import "../../all css/contactus.css";
import { contactUs } from "../../../services/api";
import AlertCustDialogBox from "../../../components/alertbox/AlertCustDialogBox";
import Alertbox from "../../../components/alertbox/Alertbox";

function ContactUs(props) {
  const [closeBtnDialog, setCloseBtnDialog] = useState(true);
  const [formData, setFormData] = useState({
    connect_name: "",
    connect_email: "",
    connect_id: "",
    connect_mobile: "",
    connect_message: "",
    connect_country_code: "",
  });

  function handleCloseDialogBox() {
    props.handleContactClick(false);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    props.handleContactClick(false);
    props.hanldeContactPopUp(true);

    let response = await contactUs({
      connect_name: formData.connect_name,
      connect_email: formData.connect_email,
      connect_mobile: formData.connect_mobile,
      connect_message: formData.connect_message,
      connect_code: formData.connect_code,
    });
  }
  return (
    <div className="contact_us_main_container">
      <div className="contact_us_under_main_container">
        <form onSubmit={handleSubmit}>
          <div className="acc_details_main_contianer">
            <InputField
              headTextInput="Name"
              inputType="text"
              placeholderText="Enter Name"
              inputId="accEmail"
              name="accEmail"
              onChange={(e) =>
                setFormData((preVal) => ({
                  ...preVal,
                  connect_name: e.target.value,
                }))
              }
            />

            <InputField
              headTextInput="Email"
              inputType="text"
              placeholderText="Enter email"
              inputId="accEmail"
              name="accEmail"
              onChange={(e) =>
                setFormData((preVal) => ({
                  ...preVal,
                  connect_email: e.target.value,
                }))
              }
            />

            <p className="input_label_text">Contact Number</p>
            <div className="contact_us_input_container">
              <div className="third_select_box_container">
                <InputField
                  headTextInput=""
                  inputType="text"
                  placeholderText="Country Code"
                  inputId="ccode"
                  name="accEmail"
                  onChange={(e) =>
                    setFormData((preVal) => ({
                      ...preVal,
                      connect_code: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="input_field_container">
                <input
                  required
                  type="number"
                  placeholder="Enter number"
                  autoComplete="off"
                  className="input_dialog_style"
                  onChange={(e) =>
                    setFormData((preVal) => ({
                      ...preVal,
                      connect_mobile: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <p className="input_label_text1">Comments</p>
            <textarea
              required
              id="aboutId"
              name="about"
              placeholder="How can we help you ?"
              className="textarea_about_style"
              onChange={(e) =>
                setFormData((preVal) => ({
                  ...preVal,
                  connect_message: e.target.value,
                }))
              }
            />
          </div>

          <div className="two_btn_container_interested">
            <div className="submit_btn_container">
              <button
                className="submit_btn_contact_us"
                onClick={handleCloseDialogBox}
              >
                Cancel
              </button>
            </div>

            <div className="submit_btn_container">
              <button className="submit_btn_contact_us">Submit</button>
            </div>
          </div>
        </form>
      </div>
      {/* <button >alert</button> */}
    </div>
  );
}

export default ContactUs;
